"use strict";

var firebaseConfig = {
  apiKey: "AIzaSyDV2MqUBcADGGSSML3og41qvtb6o9PSHhc",
  authDomain: "quran-majeed-761c6.firebaseapp.com",
  databaseURL: "https://quran-majeed-761c6.firebaseio.com",
  projectId: "quran-majeed-761c6",
  storageBucket: "quran-majeed-761c6.appspot.com",
  messagingSenderId: "780653622612",
  appId: "1:780653622612:web:7cf9e2889752584e1304c1",
  measurementId: "G-WC1FWBBLMS"
};
if (firebase.apps.length) firebase.app();else {
  firebase.initializeApp(firebaseConfig);
  var a = firebase.analytics();
  a.logEvent("web_launch", {
    some_property: "property_value"
  });
}
var provider = new firebase.auth.GoogleAuthProvider();